import React from 'react';
import ImageGallery from 'react-image-gallery'
import { Player } from 'video-react'
import 'video-react/dist/video-react.css'
import "react-image-gallery/styles/css/image-gallery.css"

export default class Gallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showIndex: false,
            showBullets: true,
            infinite: true,
            showThumbnails: true,
            showFullscreenButton: true,
            showGalleryFullscreenButton: true,
            showPlayButton: true,
            showGalleryPlayButton: true,
            showNav: true,
            isRTL: false,
            slideDuration: 450,
            slideInterval: 2000,
            slideOnThumbnailOver: false,
            thumbnailPosition: 'bottom',
            showVideo: {},
            useWindowKeyDown: true,
        };

        this.images = [
            {
                original: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg',
                thumbnail: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg',
                embedUrl: 'http://www.designwithbk.com/Media/Default/3D%20Images/PAVILION%20EXTERIOR.mp4',
                renderItem: this._renderVideo.bind(this)
            },            
            {
                original: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg',
                thumbnail: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg?w=250&h=150&fit=max',
            },
            {
                original: 'https://cdn.sanity.io/files/5t8iwfwq/production/e65b6c069664cb9d656a4d63d0bb964c794401b1.jpg',
                thumbnail: 'https://cdn.sanity.io/files/5t8iwfwq/production/e65b6c069664cb9d656a4d63d0bb964c794401b1.jpg?w=250&h=150&fit=max',
            },
            {
                original: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg',
                thumbnail: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg?w=250&h=150&fit=max',
            },
            {
                original: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg',
                thumbnail: 'https://cdn.sanity.io/files/5t8iwfwq/production/b1c8f40b3c17091cf42f22dd29fb22026e1fe077.jpg?w=250&h=150&fit=max',
            },
        ]

        // bind video player
        this.images = this.props.items.filter(x => x) // filter out undefined
        // console.log('--> gal: ', this.images)

        // check has video
        this.images.map((item, i) => {
            if(!item) return

            // if(item.hasOwnProperty('embedUrl')){
            //     item.renderItem = this._renderVideo.bind(this)
            // }
            if(item.hasOwnProperty('videoType')){
                item.renderItem = this._renderVideo.bind(this)
            }
            return item
        })
        
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.slideInterval !== prevState.slideInterval ||
            this.state.slideDuration !== prevState.slideDuration) {
            // refresh setInterval
            this._imageGallery.pause();
            this._imageGallery.play();
        }
    }

    /*
    _onImageClick(event) {
        console.debug('clicked on image', event.target, 'at index', this._imageGallery.getCurrentIndex());
    }

    _onImageLoad(event) {
        console.debug('loaded image', event.target.src);
    }

    _onSlide(index) {
        this._resetVideo();
        console.debug('slid to index', index);
    }

    _onPause(index) {
        console.debug('paused on index', index);
    }

    _onScreenChange(fullScreenElement) {
        console.debug('isFullScreen?', !!fullScreenElement);
    }

    _onPlay(index) {
        console.debug('playing from index', index);
    }

    _handleInputChange(state, event) {
        this.setState({[state]: event.target.value});
    }

    _handleCheckboxChange(state, event) {
        this.setState({[state]: event.target.checked});
    }

    _handleThumbnailPositionChange(event) {
        this.setState({thumbnailPosition: event.target.value});
    }

    _resetVideo() {
        this.setState({showVideo: {}});

        if (this.state.showPlayButton) {
        this.setState({showGalleryPlayButton: true});
        }

        if (this.state.showFullscreenButton) {
        this.setState({showGalleryFullscreenButton: true});
        }
    }
    */

    _toggleShowVideo(url) {
        this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);
        this.setState({
        showVideo: this.state.showVideo
        });

        if (this.state.showVideo[url]) {
        if (this.state.showPlayButton) {
            this.setState({showGalleryPlayButton: false});
        }

        if (this.state.showFullscreenButton) {
            this.setState({showGalleryFullscreenButton: false});
        }
        }
    }

    _renderVideo(item) {
        if(item.videoType === 'youtube'){
            return (
                <div>
                    {
                    this.state.showVideo[item.embedUrl] ?
                        <div className='video-wrapper'>
                            <a
                            className='close-video'
                            onClick={this._toggleShowVideo.bind(this, item.embedUrl)}
                            >
                            </a>
                            <iframe
                            width='560'
                            height='315'
                            src={item.embedUrl}
                            frameBorder='0'
                            allowFullScreen
                            >
                            </iframe>
                        </div>
                    :
                        <a onClick={this._toggleShowVideo.bind(this, item.embedUrl)}>
                        <div className='play-button'></div>
                        <img className='image-gallery-image' src={item.original} />
                        {
                            item.description &&
                            <span
                                className='image-gallery-description'
                                style={{right: '0', left: 'initial'}}
                            >
                                {item.description}
                            </span>
                        }
                        </a>
                    }
                </div>
            );
        }

        return (
            <div>
                <Player>
                    <source src={item.embedUrl} />
                </Player>
            </div>
        );
    }

    render() {
        return (
            <ImageGallery
                ref={i => this._imageGallery = i}
                items={this.images}
                showPlayButton={false}
            />
        );
    }
}

